import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 16px;
  height: 16px;
`

const TriangleDown = ({ title = 'Triangle Down', ...rest }: IconProps) => {
  return (
    <StyledIcon viewBox="0 0 16 16" title={title} {...rest}>
      <path fill="currentColor" d="M3 5l5 6 5-6z" />
    </StyledIcon>
  )
}

TriangleDown.displayName = 'TriangleDown'
TriangleDown.needsWork = true
export default TriangleDown
